import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import Time from "@/../bower_components/teknisavuecomponents/assets/utils/Time";
import Util from "@/../bower_components/teknisavuecomponents/assets/utils/Util";
import UtilPG from '@/assets/ts/utils/Util';
import { Periodo } from '@/../bower_components/teknisavuecomponents/assets/interfaces/interfaces';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import Field from "bower_components/teknisavuecomponents/assets/interfaces/Field";
import Dictionary from "bower_components/teknisavuecomponents/assets/interfaces/Dictionary";

@Component({
  name: 'OcorDialog',
  components: {
    TkForm,
  },
})
class OcorDialog extends Vue {
  // #region [ PROPS ]
  @Prop({ default: '' })
  private readonly date: string | string[];

  @Prop({ default: () => {} })
  private readonly defaultRow: {};

  @Prop({ default: false })
  private readonly fieldsDisplayed: {} | false;

  @Prop({ default: '' })
  private readonly hrMarcacao: string;

  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: '' })
  private readonly nrMarcacao: string;

  @Prop({ default: -1 })
  private readonly nrVinculo: number;

  @Prop({ default: undefined })
  private readonly overrideSaveAction: (row: any, isRowValid: boolean) => void;

  @Prop({ default: '' })
  private readonly title: string;

  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: '' })
  private readonly tipoHintQtHoras!: string;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ DATA ]
  private dialogTitle = 'Ocorrência';

  private internalValue = false;

  private mode = 'view';

  private internalLoading = false;

  private fileBase64 = '';
  private loadingFile = false;

  private fieldItems = {
    NMDIAGNOST: [],
  };

  private get availableFields(): Dictionary<Field> {
    return {
      NRMOTIVOOCORFREQ: {
        name: 'NRMOTIVOOCORFREQ',
        label: 'Motivo de Ocorrência',
        size: 6,
        type: 'select',
        valueField: 'NRMOTIVOOCORFREQ',
        descriptionField: 'DSMOTIVOOCORFREQ',
        route: 'getMotivoOcorFreq',
        reloadOnCreation: true,
        filters: this.genericFilter,
        required: true,
        outData: {
          NRMOTIVOOCORFREQ: 'NRMOTIVOOCORFREQ',
          IDANEXOOBRIGATORIO: 'IDANEXOOBRIGATORIO',
        },
      },
      NRTIPOPROGOCORRENCIA: {
        name: 'NRTIPOPROGOCORRENCIA',
        label: 'Tipo de Ocorrência',
        size: this.getShouldSizeBe12() ? 12 : 6,
        readonly: true,
        type: 'select',
        valueField: 'NRTIPOPROGOCORRENCIA',
        descriptionField: 'NMTIPOPROGOCORRENCIA',
        route: 'getTpOcorrencia',
        reloadOnCreation: true,
        filters: this.genericFilter,
        required: true,
      },
      NRHORDIAM: {
        name: 'NRHORDIAM',
        label: 'Horário',
        size: 6,
        readonly: false,
        type: 'autocomplete',
        valueField: 'NRHORDIAM',
        descriptionField: 'NMHORDIAH',
        route: 'getHoradiah',
        reloadOnCreation: true,
        filters: this.genericFilter,
        required: true,
      },
      DSOBSERVACAO: {
        name: 'DSOBSERVACAO',
        label: 'Observação',
        size: 12,
        type: 'textarea',
        rows: 2,
        required: true,
      },
      FILE: {
        name: 'FILE',
        label: 'Documento',
        size: 12,
        type: 'file',
        required: this.row.IDANEXOOBRIGATORIO === 'S',
      },
      CDDIAGNOST:{
        name: 'CDDIAGNOST',
        label: 'Doença',
        size: 12,
        type: 'autocomplete',
        autocomplete: true,
        valueField: 'CDDIAGNOST',
        descriptionField: 'NMDIAGNOST_VIEW',
        items: this.fieldItems.NMDIAGNOST,
      },
      NRPESSOA: {
        name: 'NRPESSOA',
        label: 'Médico/Dentista',
        size: 12,
        type: 'autocomplete',
        valueField: 'NRPESSOA',
        descriptionField: 'NMPESSOA_VIEW',
        route: 'getPessoaConselhoReg',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      QTHORAS: {
        name: 'QTHORAS',
        label: 'Quantidade de Horas',
        size: 6,
        type: 'text',
        mask: '##:##',
        hint: this.getHorasHint(),
        persistentHint: true,
        onInput: () => this.formatHours('QTHORAS')
      },
      TIPOSPROGOCORRENCIATEXT: {
        name: 'TIPOSPROGOCORRENCIATEXT',
        label: 'Tipos de Ocorrências',
        size: 6,
        type: 'text',
        required: false,
        readonly: true,
      },
    };
  }

  private row: any = {};

  private definedDefaultRow = {
    __is_new: true,
    NRTIPOPROGOCORRENCIA: '17',
  };

  protected defaultFields = [
    'NRMOTIVOOCORFREQ',
    'NRTIPOPROGOCORRENCIA',
    'DSOBSERVACAO',
    'FILE',
  ];
  // #endregion

  // #region [ STORE ]
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;
  // #endregion

  // #region [ COMPUTED ]
  private get user() {
    return this.$store.getters.user;
  }

  private get genericFilter() {
    const filter = {
      NRORG: this.user.nrorg,
      NRPERIODOAPURACAO: this.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
      CDOPERADOR: this.user.cdoperador,
    };

    return filter;
  }

  private get isLoading(): boolean {
    return this.loading || this.internalLoading;
  }

  private get fieldsToDisplayIsSet() {
    return !!this.fieldsDisplayed;
  }

  private get fieldsToShow() {
    const actionsToShow = [];
    const fieldsArray = this.fieldsToDisplayIsSet ? this.fieldsDisplayed : this.defaultFields

    for (const field in fieldsArray) {

      const currentFieldName = (fieldsArray as any)[field];
      const currentField = (this.availableFields as any)[currentFieldName];

      if (currentField) {
        actionsToShow.push(currentField);
      }
    }

    return actionsToShow;
  }

  private get fields() {
    return this.fieldsToShow;
  }

  private get saveAction() {
    if (this.overrideSaveAction) {
      return this.overrideSaveAction;
    }
    return this.save;
  }

  private get rowToSave() {
    const rowToSave = {
      NRORG: this.user.nrorg,
      NRVINCULOM: this.nrVinculo,
      HORAMARCACAO: this.hrMarcacao,
      DATE: this.date,
      ...this.row,
      FILE: this.fileBase64,
    };

    return rowToSave;
  }

  private get popUpDefaultRow() {
    return this.defaultRow ? { ...this.definedDefaultRow, ...this.defaultRow } : this.definedDefaultRow;
  }
  // #endregion

  //#region [ WATCHERS ]
  @Watch('nrOcorrencia', { immediate: true })
  private nrOcorrenciaOnChange() {
    this.mode = 'edit';
  }

  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.row = Util.deepCopy(this.popUpDefaultRow);
      this.fileBase64 = '';

      this.loadDoenca();
    }
  }
  //#endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private saveBtnOnClick() {
    this.saveAction(this.rowToSave, this.isRowValid());
  }

  private async save() {
    const route = 'setOcorrenciasFreq';
    const cdOperador: string = this.user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        NRVINCULOM: this.nrVinculo,
        // NRMARCACAOPONTO: this.nrMarcacao,
        // DTINICIOPROGOCOR: this.date,
        // DTFIMPROGOCOR: this.date,
        HORAMARCACAO: this.hrMarcacao,
        DATE: this.date,
        ...this.row,
        FILE: this.fileBase64,
        CDOPERADOR: cdOperador,
      },
    };

    this.internalLoading = true;

    try {
      const response = await HttpRequest.post(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const success = response.data.dataset.data.success;

      if (success) {
        const message = 'Ocorrência criada com sucesso!';
        SnackbarUtils.showMessage(message, 'success', 5000);
      } else {
        const message = 'Já existe uma ocorrência para a marcação selecionada.';
        SnackbarUtils.showMessage(message, 'alert', 5000);
      }

      this.closeDialog();
      this.emitAfterSave();
    } catch (err) {
      const errorMessage = 'Não foi possível criar a ocorrência.';
      SnackbarUtils.showMessage(errorMessage, 'error', 5000);

      throw err;
    } finally {
      this.internalLoading = false;
    }
  }

  private onFieldInput(fieldName: string, value: any) {
    if (fieldName === 'FILE') {
      if (value instanceof File) {
        this.createBase64File(value);
      } else {
        this.fileBase64 = '';
        this.row.NMFILE = null;
      }
    }

    if (fieldName === 'CDDIAGNOST') {
      this.doencaOnChange(this.row);
    }
  }

  private async createBase64File(file: File) {
    this.loadingFile = true;

    try {
      const fileString = await FileUtils.toBase64(file);
      this.fileBase64 = fileString;
      this.row.NMFILE = file.name;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo';
      SnackbarUtils.showMessage(message, 'alert', 5000);

      throw err;
    } finally {
      this.loadingFile = false;
    }
  }

  // Rotina necessaria pois eh necessario manipular os dados do campo NMDIAGNOST
  private doencaOnChange(row) {
    const CIDData = this.fieldItems.NMDIAGNOST;
    const rowCDDIAGNOST = row.CDDIAGNOST;
    if (!rowCDDIAGNOST) {
      return;
    }
    
    const doencaData = CIDData.find((item) => item.CDDIAGNOST === rowCDDIAGNOST);
    if (!doencaData) {
      row.CDTABECDI = null;
      return;
    }
    
    row.CDTABECDI = doencaData.CDTABECDI;
  }

  private async loadDoenca() {
    // Request doencas
    if (!this.fieldItems.NMDIAGNOST || (Array.isArray(this.fieldItems.NMDIAGNOST) && this.fieldItems.NMDIAGNOST.length === 0)) {
      try {
        const response = await HttpRequest.get('getDiagnost', {
          requestType: 'FilterData',
          NRORG: this.user.nrorg,
        }, false);
  
        if (typeof response.data === 'string') {
          throw new Error(response.data);
        }

        this.fieldItems.NMDIAGNOST = response.data.dataset.data;
      } catch (err) {
        const message = 'Não foi possível carregar as informações de doença.';
        SnackbarUtils.showMessage(message, 'error');
  
        throw err;
      }
    }
  }

  private isRowValid() {
    return Util.verifyFormRequired(this.row, this.fields);
  }

  private formatHours(key: string) {
    // Formata a saída como "HH:MM"
    const horas = UtilPG.formatHours(this.row[key]);

    this.$nextTick(() => {
      this.row[key] = horas;
      const rowCopy = Util.deepCopy(this.row);
      this.row = { ...rowCopy };
    });
  }

  private getHorasHint(): string | null {
    if (this.tipoHintQtHoras === 'horasExtrasNoBancoDeHoras') {
      return 'O que ultrapassar esse valor será lançado como banco de horas.';
    }
    if (this.tipoHintQtHoras === 'bancoDeHorasNasHorasExtras') {
      return 'O que ultrapassar esse valor será lançado como horas extras.';
    }
    return null;
  }

  private getShouldSizeBe12(): boolean {
    return this.tipoHintQtHoras === 'bancoDeHorasNasHorasExtras';
  }
  // #endregion
}

export default OcorDialog;